import { ArticleAction } from "../../models/article"
import { articlePath } from "../../routerPaths"
import { KNOWLEDGE_BASE_PATH } from "./constants"

export const buildArticleActionUrl = (url: string, action: ArticleAction, symbolCode: string) => {
    return `${url.replace(/\/+$/, "")}${articlePath}/${action}/${symbolCode}`
}

export const buildSharedArticleActionUrl = (url: string, symbolCode: string) =>
    `${url.replace(/\/+$/, "")}${articlePath}/${symbolCode}`

export const normalizeArticleSharedUrl = (sharedUrl: string) =>
    `${window.location.protocol}//${window.location.host}/app${sharedUrl}`

export const buildKnowledgeBaseArticleUrl = (url: string, action: ArticleAction, symbolCode: string) => {
    const cleanBase = url.split("/").filter(Boolean)
    const baseParts = cleanBase.slice(0, 2)
    const basePath = "/" + baseParts.join("/")
    return `${basePath}/${KNOWLEDGE_BASE_PATH}${articlePath}/${action}/${symbolCode}`
}
